// The second argument to both constructors is a valid ISO Country Code. These
// codes are the upper-case two-letter codes as defined by ISO-3166. You can
// find a full list of these codes at a number of sites like here. Also three
// letter codes for countries are available.
export const languageRegionCodes = [
  'da-DK',
  'nl-NL',
  'en-US',
  'en-GB',
  'fr-FR',
  'de-DE',
  'it-IT',
  'nb-NO',
  'pl-PL',
  'pt-PT',
  'pt-BR',
  'es-ES',
  'es-MX',
  'sv-SE'
] as const;

export type LanguageRegionCode = (typeof languageRegionCodes)[number];
